import { Link } from 'react-router-dom';
import { categories } from '@/mocks/manhua';

export default function CategoryNav() {
  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="px-4 md:px-8 lg:px-16">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 border border-foreground-300 text-foreground-700 text-xs font-medium rounded-full whitespace-nowrap">
            分类导航
          </span>
          <h2 className="mt-4 text-2xl md:text-4xl font-bold text-foreground-950 font-heading leading-tight">
            探索你喜欢的
            <br />
            韩漫类型
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
            六大分类，涵盖最热门的韩漫题材，总有一款适合你
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 max-w-5xl mx-auto">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 border border-background-200 rounded-lg p-6 hover:bg-primary-500 hover:border-primary-500 transition-all duration-300"
            >
              <div className="w-12 h-12 rounded-lg bg-secondary-100 flex items-center justify-center mb-4 group-hover:bg-background-50/20 transition-colors">
                <i className={`${cat.icon} text-xl text-secondary-600 group-hover:text-background-50 transition-colors`}></i>
              </div>
              <h3 className="text-lg font-bold text-foreground-900 group-hover:text-background-50 transition-colors font-heading">
                {cat.name}
              </h3>
              <p className="mt-2 text-xs text-foreground-500 group-hover:text-background-50/80 transition-colors line-clamp-2">
                {cat.description}
              </p>
              <div className="mt-4 flex items-center justify-between">
                <span className="text-xs text-foreground-400 group-hover:text-background-50/60 transition-colors whitespace-nowrap">
                  {cat.count}部作品
                </span>
                <span className="text-xs font-medium text-primary-500 group-hover:text-background-50 transition-colors flex items-center gap-1 whitespace-nowrap">
                  浏览分类
                  <i className="ri-arrow-right-line text-[10px]"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}